import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import { Table, TableBody, TableCell, TableRow } from '@mui/material';
import DocumentScoringHistoryItemComponent from 'features/document/edit/scoringHistory/components/DocumentScoringHistoryItemComponent';
import { RightsContext } from 'providers/RightsContext';
import { Card } from '@totalsoft/rocket-ui';
import { BoldTableHead } from 'components/common/CommonStyles';

export const DocumentScoringSessionHistoryListComponent = ({ t, onOpenScoringSessionHistory, scoringSessionHistory }) => {
  const { scoringGridAssetRead, scoringGridClientRead, scoringGridDocumentRead } = useContext(RightsContext);

  return (
    <Card title={t('OfferEdit.ScoringHistory.Title')}>
      <Table>
        <BoldTableHead>
          <TableRow>
            <TableCell>{t('OfferEdit.ScoringHistory.Date')}</TableCell>
            {scoringGridAssetRead && <TableCell>{t('OfferEdit.ScoringHistory.AssetResult')}</TableCell>}
            {scoringGridClientRead && <TableCell>{t('OfferEdit.ScoringHistory.ClientResult')}</TableCell>}
            {scoringGridDocumentRead && <TableCell>{t('OfferEdit.ScoringHistory.DocumentResult')}</TableCell>}
            <TableCell>{t('')}</TableCell>
          </TableRow>
        </BoldTableHead>
        <TableBody>
          {scoringSessionHistory.map((sessionItem, index) => {
            return (
              <DocumentScoringHistoryItemComponent
                sessionItem={sessionItem}
                key={index}
                onOpenScoringSessionHistory={onOpenScoringSessionHistory}
              />
            );
          })}
        </TableBody>
      </Table>
    </Card>
  );
};

DocumentScoringSessionHistoryListComponent.propTypes = {
  t: PropTypes.func.isRequired,
  scoringSessionHistory: PropTypes.array.isRequired,
  onOpenScoringSessionHistory: PropTypes.func.isRequired
};

export default compose(withTranslation())(DocumentScoringSessionHistoryListComponent);
